export default () => {
  const iheartStrapContainers = document.querySelectorAll('.js-strap-iheart');

  console.log(iheartStrapContainers);

  if (!iheartStrapContainers) {
    return;
  }

  iheartStrapContainers.forEach(strapIheartContainer => {
    const isDone = strapIheartContainer.dataset.isDone;
    if (isDone) return;

    const artistId = strapIheartContainer.dataset.artistId;
    if (!artistId) return;

    import('./Strap_Iheart' /* webpackChunkName: "strapiheart" */).then(
      ({ initializeForElement }) => {
        initializeForElement(strapIheartContainer, {
          artistId,
        });
      }
    );
  });
};
